module.exports = [
  [ // Red
    [94.674970033051, 7.2667150668638, 1.0007438822724, 7.3353006878308, 7.8412297562015],
    [86.78974167617, 18.370736761658, 4.2363713397142, 18.852872759717, 12.985645759128],
    [72.093916283256, 31.794805829812, 13.29724439969, 34.463406482536, 22.695688709724],
    [61.793533700519, 44.129498163765, 20.7214773268, 48.752356156301, 25.152904302221],
    [57.19419539895, 59.645000619736, 34.99983001294, 69.155724274011, 30.404513383318],
    [55.603951071861, 66.012873848455, 47.671693139828, 81.426591728685, 35.835216455852],
    [51.663485029547, 64.748778502063, 43.244876694855, 77.862209561908, 33.738452055984],
    [47.09455666351, 62.298360390743, 40.677754246984, 74.402724398727, 33.142553888932],
    [43.771220633887, 60.286335091834, 40.31444686693, 72.523767311078, 33.771286719474],
    [39.555187078007, 58.70368135539, 41.664950277986, 71.986736877999, 35.365235525334]
  ],
  [ // Pink
    [92.680537763277, 9.5153852328043, -0.89940729697549, 9.5577973202262, 354.60036662931],
    [81.867566436289, 25.056880897233, -1.9475235115391, 25.1324516935, 355.55567219102],
    [70.909873895458, 42.217052577205, -1.095154624058, 42.231254918095, 358.5140206478],
    [61.081408052162, 58.871233307587, 2.1008764804626, 58.908707277808, 2.0437876142136],
    [54.979702199864, 68.565309383669, 7.3274307285606, 68.95573139312, 6.0999281090199],
    [50.872250340749, 74.604591959255, 15.353576256896, 76.168086790225, 11.629071389127],
    [47.277386501446, 70.778557764278, 11.704342732645, 71.739778909573, 9.3897792583505],
    [42.584241894865, 65.541195313831, 7.5955964398038, 65.97985577767, 6.6105425268806],
    [37.977492407255, 60.743626218421, 2.9847124951453, 60.816910763717, 2.8130358769794],
    [29.69929003485, 51.904850237213, -4.8301866341076, 52.129110687483, 354.68345327154]
  ],
  [ // Purple
    [92.436265516902, 7.5429274677023, -6.0398428486059, 9.6630976616649, 321.31472250002],
    [81.073997769048, 19.563870217805, -15.719625491986, 25.096845289945, 321.21802350737],
    [68.713947177118, 33.799928124906, -26.495399723393, 42.946959703234, 321.90748468871],
    [56.596161226236, 47.585663183515, -36.480816605411, 59.960364582052, 322.52497703379],
    [48.002791217624, 57.308664439349, -43.256112715255, 71.800935279819, 322.95479243892],
    [40.662115346922, 64.019107738184, -48.05930162591, 80.050875250452, 323.10435234559],
    [37.690702208992, 61.137627677325, -49.384803274243, 78.59178272852, 321.06995435069],
    [33.56291870732, 57.637381239254, -51.395572498558, 77.224171012538, 318.27643501449],
    [29.865391314235, 54.297374399013, -52.660197371246, 75.639283800187, 315.876945947],
    [23.167242354204, 48.517644372805, -55.162679490153, 73.463480886896, 311.33283907206]
  ],
  [ // Deep purple
    [92.491034260172, 4.7123200257529, -6.5328680717098, 8.0550807114192, 305.80384783476],
    [81.246683195056, 11.506427349095, -16.666600637245, 20.252739250319, 304.62074788545],
    [68.614882165546, 20.395329051983, -28.522018851715, 35.063870386999, 305.56754018699],
    [55.60369793053, 30.933537768905, -41.164391223585, 51.491658195368, 306.92352571205],
    [45.834566190969, 39.288062722357, -50.523322052773, 64.001233923449, 307.86943330862],
    [36.608620229359, 47.296860028281, -59.111766586187, 75.704649246098, 308.66420919437],
    [34.189791237563, 46.604260651391, -59.539616276767, 75.610336708994, 308.05183996081],
    [30.527133673384, 46.014982247545, -60.199750525091, 75.771950974784, 307.39327064884],
    [27.445855248772, 44.961804318548, -60.463958107564, 75.348882391265, 306.63498353744],
    [21.986276703282, 44.292960762455, -60.936536551721, 75.3334444986, 306.01229105011]
  ],
  [ // Indigo
    [92.863144119839, 1.5318147061062, -6.0252435289506, 6.2169136938681, 284.26427230461],
    [81.83480737053, 4.4609349554589, -15.873561009736, 16.488477182768, 285.69691628676],
    [69.779691379567, 7.9043652558913, -26.317084634693, 27.478499481743, 286.71769787323],
    [57.487865199387, 12.681019504823, -37.232020129145, 39.332322313573, 288.80855799532],
    [47.745925788111, 18.520799302452, -46.475406790004, 50.029825535355, 291.72765384785],
    [38.334403614455, 25.577006681708, -55.282241532993, 60.912309919328, 294.82819934871],
    [35.151164539016, 26.231812080381, -54.537009787854, 60.517711470452, 295.68713669857],
    [31.080429988008, 27.073949301101, -53.9750527458, 60.38464249849, 296.63839612797],
    [27.026672080455, 28.165266427559, -53.289873254822, 60.275142674658, 297.85776988597],
    [19.751201587922, 30.607845768951, -52.138665192975, 60.458916883459, 300.41493579422]
  ],
  [ // Blue
    [94.706824573487, -2.8354847359873, -6.9780446947927, 7.5321365793871, 247.88594204577],
    [86.883984297002, -5.1690872875955, -17.88561192755, 18.617587851537, 253.88027612283],
    [79.045153240156, -6.8177535270157, -28.968537490432, 29.760005502179, 256.75643084317],
    [71.150836972426, -5.9947637568507, -39.725494511589, 40.175267350582, 261.41854637855],
    [65.481060589078, -2.7357457925379, -48.154712389266, 48.23236082066, 266.74843084915],
    [60.430094408509, 2.0799288973216, -55.109358470696, 55.148594680822, 272.16142257498],
    [55.622676769222, 4.9986843844869, -55.021647294299, 55.24824446581, 275.1910376505],
    [49.270066459049, 8.4703983703144, -54.494796838458, 55.149166186051, 278.8350699173],
    [43.168288563944, 11.968483076144, -53.972567377978, 55.283655961905, 282.50308907467],
    [32.177577938942, 18.960549902294, -53.451463650491, 56.714737229199, 289.53084867016]
  ],
  [ // Light Blue
    [95.357134677627, -4.7971491553882, -6.5500025505043, 8.1188160116272, 233.78136662451],
    [88.2794264954, -10.836006614584, -16.35936182194, 19.622633833725, 236.48056690431],
    [81.10009044901, -15.323054522982, -26.419121191321, 30.541217468136, 239.88632489371],
    [74.447139582598, -16.664432625363, -35.197026869, 38.942701692902, 244.66425288912],
    [69.878364656373, -14.291515332055, -41.827430329755, 44.201598822632, 251.13582779396],
    [65.688512591789, -9.6126357219637, -47.340916160392, 48.30698819455, 258.52206273917],
    [60.88357994309, -7.2528190271849, -46.677537315956, 47.237653135222, 261.16793080854],
    [54.261664954262, -3.8141836897908, -45.979394757625, 46.137324797792, 265.25793218384],
    [48.106618950727, -1.3789987844643, -44.344667502068, 44.366103880288, 268.21883079481],
    [36.344011470573, 5.0678124047135, -43.117862575619, 43.414661068115, 276.70344414645]
  ],
  [ // Cyan
    [95.692951545998, -6.8987161273011, -3.9942842296544, 7.9716115505179, 210.07039093303],
    [89.52842524059, -16.412398289602, -9.2604660692667, 18.844708791504, 209.43325611953],
    [83.320312146557, -24.830368407281, -14.568673583305, 28.788772902265, 210.40134402675],
    [77.35338313753, -30.201708572215, -18.923582847211, 35.640499273386, 212.07015778241],
    [73.453220938578, -31.885903901894, -21.130459992514, 38.251891549779, 213.53202612646],
    [69.976384650648, -30.679850324548, -23.186685661137, 38.456151756059, 217.08062694428],
    [64.444917165538, -29.083374345845, -21.154935769156, 35.963508876883, 216.03174224719],
    [56.998164329611, -27.310814772795, -17.869888157674, 32.637608771503, 213.1973437715],
    [49.754641822557, -25.335383503694, -15.024722591663, 29.455456985687, 210.66934656131],
    [36.527258942644, -22.129641744195, -9.1761591468943, 23.956688844988, 202.52156868026]
  ],
  [ // Teal
    [94.184539415899, -6.0835170342897, -1.5488916051162, 6.2775986420679, 194.28427989359],
    [85.681770774145, -15.333179440299, -2.8519825761476, 15.596159667144, 190.53664839551],
    [76.850678471904, -24.84405917319, -3.8750785132193, 25.14445286111, 188.86533707626],
    [68.027622425701, -32.566861154121, -4.0152310844071, 32.813450383844, 187.02863645389],
    [61.667257304525, -36.067526032894, -3.4734046401754, 36.234389382572, 185.5007820884],
    [55.673103973902, -36.660699606263, -2.1256179151697, 36.722270451893, 183.31834186406],
    [51.059149495198, -34.650191603014, -1.3910484300433, 34.678102512397, 182.29893183127],
    [45.269081019218, -32.132447754229, -0.45263718526978, 32.135635657316, 180.80704978883],
    [39.368990760594, -29.252644685832, -0.035625646731707, 29.252666379362, 180.06977824443],
    [28.583630437015, -24.585465516136, 1.8037402162492, 24.651543428614, 175.80394871997]
  ],
  [ // Green
    [95.305301835652, -6.4304156457393, 4.2929505944596, 7.7317313832957, 146.27289504171],
    [88.490145791521, -15.231477449527, 10.848261177683, 18.699804166747, 144.54052479153],
    [81.226168705754, -24.993886168552, 18.144696803331, 30.885666058729, 144.02164822159],
    [74.303617215588, -35.560886960674, 26.781515251908, 44.517707045826, 143.01596811715],
    [69.043099527744, -42.61556126596, 33.171095631267, 54.003774380977, 142.1035276248],
    [63.977421814073, -48.5429267332, 39.732415263429, 62.730220456255, 140.69965359035],
    [58.777960853461, -46.115369247801, 37.838910745226, 59.652413591121, 140.63019338824],
    [52.411086889749, -43.217617924858, 35.622506590094, 56.006477079533, 140.5026431655],
    [46.281387307643, -40.258162276754, 33.323432293388, 52.2606043757, 140.38396322331],
    [34.685655305815, -34.753438785103, 28.86673903436, 45.178425491242, 140.28645813743]
  ],
  [ // Light green
    [96.70518169356, -4.9299878450955, 6.3970845231689, 8.0763525523194, 127.62006347836],
    [91.664160611994, -12.057032041946, 16.054604579275, 20.077907008884, 126.90660411778],
    [86.224439586545, -19.613646834081, 26.384906423454, 32.876411439001, 126.62586416134],
    [80.834048796369, -27.080171840757, 37.378493742021, 46.157204219355, 125.92277987192],
    [76.79543725109, -32.766597197368, 45.912190572444, 56.405488518893, 125.51467857689],
    [72.90025297028, -37.549139223927, 53.51959496103, 65.378015427593, 125.05334997795],
    [67.215323102721, -36.563048707735, 50.496290512689, 62.343659552083, 125.90731832095],
    [59.910511422102, -35.770114660634, 46.564658479762, 58.717701949002, 127.53080735942],
    [52.510158410845, -34.479034406992, 42.207238687243, 54.500044139803, 129.24533833347],
    [39.411919833539, -32.804609743526, 35.25549058563, 48.156952113464, 132.93763929718]
  ],
  [ // Lime
    [97.995060578834, -4.0596324827415, 9.3557976023815, 10.198606016101, 113.45680477892],
    [94.809262359765, -9.2370914673529, 23.230650064825, 24.999739222852, 111.68401435118],
    [91.852058435262, -15.053917327011, 38.861151822066, 41.675047064474, 111.17522309799],
    [88.758121420802, -19.542900400164, 53.717856757837, 57.162339793838, 109.99171092235],
    [86.274041807295, -22.173992891122, 63.978639065233, 67.712275234073, 109.11551410823],
    [84.205668353765, -24.270643520989, 72.79624067033, 76.735629225644, 108.43865345895],
    [78.27915100604, -21.181850056402, 68.82763412298, 72.013290376004, 107.10585932329],
    [70.823858118928, -17.788148932526, 64.003278179881, 66.429194336654, 105.53197311896],
    [62.936867012868, -13.697412111685, 58.513000509288, 60.09484443076, 103.1752271038],
    [49.498610881453, -6.4852305643847, 49.674327228338, 50.095878084541, 97.438179198513]
  ],
  [ // Yellow
    [98.938851297528, -3.0098470288543, 10.76573683379, 11.178562909047, 105.61974330115],
    [97.226897848241, -6.1745993687345, 26.229324173551, 26.946300747331, 103.24671615161],
    [95.580929478288, -8.9071328484739, 43.562972914466, 44.46425108699, 101.55574349617],
    [94.090095157025, -10.509628942711, 60.200195142312, 61.110684791499, 99.902782811447],
    [93.065467466831, -11.008558476013, 71.765008260055, 72.60444043091, 98.721037741066],
    [92.129750177601, -10.830023094868, 80.909055964009, 81.630660521783, 97.623967812625],
    [87.121883491686, -2.3764300099239, 78.148681953734, 78.184806137113, 91.741775552793],
    [80.962004424199, 8.8493337927291, 75.050507000927, 75.570426157799, 83.275207132809],
    [75.003427707181, 20.340173566879, 72.248419259589, 75.057023297225, 74.276440514467],
    [65.482077574316, 39.647064970476, 68.348728417687, 79.015431638939, 59.883254475713]
  ],
  [ // Amber
    [97.564239207434, -1.445525639405, 11.881254316298, 11.968865798509, 96.936764001137],
    [93.670579537495, -1.8693096862072, 30.028886704157, 30.087013068665, 93.562087779938],
    [89.945714928041, -1.022450381477, 49.649542361642, 49.660069084759, 91.179745263663],
    [86.710091641538, 1.0496066396428, 68.773773424097, 68.781782363406, 89.125635265665],
    [83.787739933192, 5.2482318200984, 78.929204578527, 79.103497221276, 86.195837241373],
    [81.521913820802, 9.4036553707072, 82.692571129827, 83.225537273078, 83.51229380837],
    [78.172409738047, 16.628512886532, 81.093583188062, 82.780895592502, 78.411939004905],
    [73.808996543811, 26.536143152509, 78.217540521817, 82.596310684513, 71.259941144556],
    [70.113451166576, 35.300762335974, 75.875109921386, 83.684981490608, 65.049878374945],
    [63.864604055657, 50.94648214506, 72.178156821244, 88.347214812177, 54.783893210911]
  ],
  [ // Orange
    [96.304595178014, 0.92315117228248, 10.598439446083, 10.638567891365, 85.021954985529],
    [90.683200828651, 4.1037749646811, 26.485793721916, 26.801832736599, 81.192484528455],
    [85.000552871862, 9.0471817588667, 44.514076225808, 45.424161852642, 78.511506689398],
    [79.42428495743, 16.45261072444, 62.087217390742, 64.230140611517, 75.158205704625],
    [75.477926992898, 23.395742928452, 72.643476112365, 76.317988763213, 72.148194501936],
    [72.042465615484, 30.681921012382, 77.085792989046, 82.967462042418, 68.296305265449],
    [68.94724338947, 35.220147784339, 74.884250445951, 82.753306730321, 64.811092156232],
    [64.830174955352, 40.912007300997, 71.959605354543, 82.776670289269, 60.379981582389],
    [60.853420747187, 46.414835905107, 69.180619634152, 83.308433697095, 56.141449767942],
    [54.775717429623, 55.28275101936, 65.101934035479, 85.40751943142, 49.663010696935]
  ],
  [ // Deep Orange
    [93.69219844672, 5.7639793343583, 3.1700162796469, 6.5781806740265, 28.809478366813],
    [86.046294342764, 15.750843803958, 14.828476927091, 21.632679180211, 43.27230594013],
    [77.540100429383, 27.9011384254, 25.996452292891, 38.135142024777, 42.976067570526],
    [69.740954567079, 41.144873775523, 39.4433201789, 56.997159093581, 43.790426348743],
    [64.370853445393, 51.890379620444, 50.813124710464, 72.626339161457, 44.399047804426],
    [60.067808372774, 61.652587361188, 61.547718291652, 87.11580313145, 44.951229393443],
    [57.287079152324, 60.325066430881, 60.073415363764, 85.134768886499, 44.880243314999],
    [53.810052616294, 58.367609437802, 58.195868066949, 82.422914845021, 44.915582060453],
    [50.301352405106, 56.401048980899, 55.924141992404, 79.426620120287, 44.756736728106],
    [43.864779945483, 52.970887703911, 52.300679892255, 74.439747859141, 44.635233320023]
  ],
  [ // Brown
    [93.2986488807, 0.99154560904757, 1.4423530763784, 1.7502985721755, 55.493422737647],
    [82.808843590041, 3.1162219033422, 3.3523059451463, 4.5769852633292, 47.090215617593],
    [70.954930476682, 5.4697421933448, 5.4490094945535, 7.7207372791328, 44.891205996348],
    [58.712934619103, 7.9909910753634, 8.3524884953676, 11.559411854925, 46.267104695747],
    [49.150208552876, 10.570984981, 10.831440151198, 15.134920522339, 45.697222174855],
    [39.632001518377, 13.138881961627, 13.531574711512, 18.860904892788, 45.843555540918],
    [35.600996682016, 12.403528477573, 12.104321839024, 17.330958596588, 44.300533269519],
    [30.08427126576, 11.317148149878, 10.547484304296, 15.47020579681, 42.983945580078],
    [24.555014696417, 10.816613316782, 8.506555306792, 13.760835978686, 38.182723376249],
    [18.350552265144, 10.225725550339, 7.0585827698826, 12.425339180487, 34.616424630095]
  ],
  [ // Gray
    [98.272027409802, -1.6418393644635e-5, 6.567357457854e-6, 1.7683151128954e-5, 158.19859051365],
    [96.537493365486, -1.6169179051229e-5, 6.467671598287e-6, 1.741473878914e-5, 158.19859058148],
    [94.097837898778, -1.5818653831268e-5, 6.3274615325071e-6, 1.7037211581678e-5, 158.19859051365],
    [89.177283734936, -1.5111677686974e-5, 6.0446710747897e-6, 1.627577497133e-5, 158.19859051365],
    [76.611199022313, -1.3306205914887e-5, 5.3224823437503e-6, 1.433122235362e-5, 158.19859059607],
    [65.114247741275, -1.1654345155598e-5, 4.6617380622394e-6, 1.2552113876425e-5, 158.19859051365],
    [49.238989620828, -9.3734174311244e-6, 3.7493669724498e-6, 1.0095479534534e-5, 158.19859051365],
    [41.142668438048, -8.2101529463863e-6, 3.2840611896567e-6, 8.8426053457375e-6, 158.19859044686],
    [27.974857206004, -6.3182261922368e-6, 2.5272904768947e-6, 6.8049378667898e-6, 158.19859051365],
    [12.740011331303, -4.1293116981311e-6, 1.6517246792525e-6, 4.4474048068929e-6, 158.19859051365]
  ],
  [ // Blue Gray
    [94.276652125162, -0.63757104610934, -1.3135153789967, 1.4600751657698, 244.10839271013],
    [85.777880014921, -2.2777811084513, -3.0177758416152, 3.7809070086758, 232.95493147037],
    [76.122963250152, -3.4015029888838, -5.1686789297791, 6.1875249060127, 236.65112106668],
    [66.163401089084, -4.819627183079, -7.5206976316144, 8.9325079932819, 237.34628468545],
    [58.357524785136, -5.7195089100892, -9.1659889166135, 10.804079553209, 238.03614349068],
    [50.707480822027, -6.8379929657995, -10.956055112409, 12.91484771209, 238.0305126281],
    [44.859178676476, -6.4119905592396, -9.7451198287877, 11.665375407984, 236.65630748667],
    [36.924589305665, -5.3198786108456, -8.3419434745616, 9.8938935392955, 237.47326196223],
    [29.115334784638, -4.1689078286451, -6.8629962199973, 8.0299756910862, 238.72352912138],
    [19.9583384508, -3.3116721453187, -5.4486142104737, 6.376093569942, 238.70873180375]
  ]
]
